import { Geometry, TextStyle } from "../../drawing";

/**
 * TODO: RichTextItemはimplementsしていないのでTextBoxItemのほうしか判定できない
 */
export interface IHeightAutoAdjustable {
  shouldAutoAdjustHeight: boolean;
  originalHeight: number;
  text(): string;
  geometry: Geometry;
  textStyle: TextStyle;
}

export function instanceOfIHeightAutoAdjustable(instance: any): instance is IHeightAutoAdjustable {
  if (!instance) { return false; }
  return (instance.shouldAutoAdjustHeight !== undefined)
    && (instance.originalHeight !== undefined)
    && (instance.text !== undefined)
    && (instance.geometry !== undefined)
    && (instance.textStyle !== undefined);
}
